module.exports = __webpack_public_path__ + "static/img/img-13.026a029.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-13.jpg
// module id = 96
// module chunks = 0